import { SOCKET } from 'flaivy-react/reducers/action-type';
import { replaceInlistIfExists } from 'flaivy-react/utils/array-helper';
import _ from 'lodash';
import { ACTION_TYPES } from '../actions/generated/stock-article.actions';

const initialState = {
  errorMessage: null,
  entities: [],
  hasMore: true,
  currentPage: 0,
  total: 0,
  query: {},
  loading: false,
  sort: 'name',
  search: '',
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case ACTION_TYPES.SET_STOCK_ARTICLE_LIST: {
      return {
        ...state,
        ...action.payload,
      };
    }

    case SOCKET('ARTICLE_CREATED'): {
      const entity = action.payload.fullEntity;
      // eslint-disable-next-line  no-underscore-dangle
      entity._recentCreate = true;
      const merged = _.merge(
        _.keyBy([entity], 'id'),
        _.keyBy(state.entities, 'id'),
      );
      const entities = _.values(merged);
      return {
        ...state,
        // needs to be replace in list as events might trigger twice due to generated code below
        entities,
        total: state.total + 1,
      };
    }
    case SOCKET('ARTICLE_UPDATED'):
    case SOCKET('ARTICLE_CREATED'):
    case SOCKET('ARTICLE_ACTIVATED'):
    case SOCKET('ARTICLE_DEACTIVATED'):
    case SOCKET('ARTICLE_CAMPAIGN_STARTED'):
    case SOCKET('ARTICLE_CAMPAIGN_ENDED'):
    case SOCKET('ARTICLE_PUBLISHED_ON_WHITELABEL'):
    case SOCKET('ARTICLE_PUBLISHED_ON_OUR_STORE'):
    case SOCKET('ARTICLE_PUBLISHED_ON_PRO'):
    case SOCKET('ARTICLE_PUBLISHED_ON_STOCKFILLER'):
    case SOCKET('ARTICLE_UNPUBLISHED_ON_WHITELABEL'):
    case SOCKET('ARTICLE_UNPUBLISHED_ON_OUR_STORE'):
    case SOCKET('ARTICLE_UNPUBLISHED_ON_PRO'):
    case SOCKET('ARTICLE_UNPUBLISHED_ON_STOCKFILLER'):
    case SOCKET('ARTICLE_STOCKCHANGE'):
    case SOCKET('ARTICLE_BATCH_BLOCKED'):
    case SOCKET('ARTICLE_BATCH_UNBLOCKED'):
    case SOCKET('ARTICLE_QUANTITY_IN_EXACTA_STOCK_CHANGED'):
    case SOCKET('ARTICLE_CUSTOMER_SUB_UNIT_SPECIFIC_ARTICLE_CREATED'):
    case SOCKET('ARTICLE_CUSTOMER_SUB_UNIT_SPECIFIC_ARTICLE_UPDATED'):
    case SOCKET('ARTICLE_METADATA_CHANGED'): {
      const entity = action.payload.fullEntity;
      const entities = replaceInlistIfExists([entity], state.entities);
      return {
        ...state,
        entities,
      };
    }
    default:
      return state;
  }
};

export default reducer;
